// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__NT5cT","content":"GlobalSearch_content__3HznG"};